import * as React from 'react';
import * as classNames from 'classnames';
import LoadingBars from '@reverbdotcom/commons/dist/components/loading_bars';

function LoadingOverlay(props) {
  const {
    showOverlay,
    children,
  } = props;

  const classes = classNames('loading-overlay', {
    'loading-overlay--active': showOverlay,
  });

  return (
    <div className={classes}>
      <div className="loading-overlay__content">
        {children}
      </div>
      {showOverlay &&
        <div className="loading-overlay__bars">
          <LoadingBars />
        </div>
      }
    </div>
  );
}

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading_overlay.jsx